module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/description-pict-63fc66a6686f4229819d26bfaac20a6f.jpg";